import { useEffect } from 'react';
import { useLayoutStore } from '@/app/layouts/use-layout-store';

/** Enquanto a tela estiver aberta, o conteudo fica sobre branco. */
export function usePlainBackground() {
  const setPlainBackground = useLayoutStore((state) => state.setPlainBackground);

  useEffect(() => {
    setPlainBackground(true);

    return () => setPlainBackground(false);
  }, [setPlainBackground]);
}
